import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { AutoComplete } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { AddressSearchResult } from './addressSearchResult';
import { useGetSearchAddressMutation } from '../../../../../data/customer';
import { isRequired } from '../../../../../utils/validationUtils';
import { FORM_KEYS } from '../../../../../constants/formKeys';
import { VALIDATION_ERROR_MESSAGE } from '../../../../../constants/errorMessage';

const { POLICY_HOLDER_ADDRESS_AUTOCOMPLETE_SEARCH } = FORM_KEYS;

export const AddressSearch = ({ onSelect, fieldFormContext, setNewAddress }) => {
  const [getSearchAddress, { data: searchAddress, isLoading: searchAddressLoading }] = useGetSearchAddressMutation();
  const [selectedAddress, setSelectedAddress] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const { watch } = fieldFormContext;
  const searchInput = watch(POLICY_HOLDER_ADDRESS_AUTOCOMPLETE_SEARCH);

  const srInstruction = `Use this input to search for your address.
        A list of addresses will be created below that can be accessed using the tab key
        and selected using Enter or Space. If you would prefer to enter your address manually 
        you can use the button below to toggle into manual entry mode.`;

  const handleSearch = (searchValue) => {
    if (searchValue.length >= 4) {
      getSearchAddress(searchValue);
    }
  };

  useEffect(() => {
    if (searchAddress?.responseObject) {
      const addressResults = searchAddress.responseObject.map((item) => ({
        mainText: item.FullAddress,
        globalAddressKey: item.GlobalAddressKey
      }));
      setSearchResults(addressResults);
    }
  }, [searchAddress]);

  useMemo(() => {
    if (searchInput === '') {
      setSelectedAddress('');
      setSearchResults([]);
      setNewAddress('');
    }
  }, [searchInput, setNewAddress]);

  const handleSelect = (selectedAddress) => {
    setSelectedAddress(selectedAddress);
    onSelect(selectedAddress);
  };

  return (
    <div className="addressSearch">
      <AutoComplete
        {...{
          name: POLICY_HOLDER_ADDRESS_AUTOCOMPLETE_SEARCH,
          minCharacters: 4,
          label: 'Enter address',
          placeholder: 'Start typing to lookup address',
          fieldFormContext,
          validation: { required: isRequired(VALIDATION_ERROR_MESSAGE.INVALID_ADDRESS) },
          defaultValue: selectedAddress,
          srInstruction,
          ResultMarkup: ({ result, clickHandler }) => AddressSearchResult({ result, clickHandler }),
          searchResults,
          onSearch: handleSearch,
          onSelect: handleSelect
        }}
      />
    </div>
  );
};

AddressSearch.propTypes = {
  onSelect: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: PropTypes.any,
  setNewAddress: PropTypes.func
};
